import React, { Component, createRef } from 'react';
import { Box, type Theme } from '@mui/material';

import {pink,green,grey, purple} from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionActions from '@mui/material/AccordionActions';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import {ClosableBar, LoadDialog,} from '../../components/dialogs';
import {Download,} from '../../ajax';
import { CSVIcon, JSONIcon, ZIPIcon} from '../../components/icons';
import { clone, errorMessage } from '../../core';
import { formatDate } from '../../components/renderers';
import { create, isValid } from '../../components/form';
import { bizupload } from '../../ajax/bizrequest';

const s:any ={
  root: {
    width: '100%',
  },
  titlebar: {
    padding:0,
    backgroundColor: 'success.light',
  },
  summary: {
    alignItems: 'space-between'
  },
  heading: (theme:Theme)=> ({
    fontSize: theme.typography.pxToRem(15),
  }),
  secondaryHeading: (theme:Theme)=> ({
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  }),
  topheading: {
    fontWeight:'bold',
  },
  close: {
    flexBasis: '33.33%',
    align:'right'
  },
  details: {
    alignItems: 'center',
    p: 1,

  },
  column: {
    flexBasis: '33.33%',
  },
  iconsroot: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  pdficon: {
    m: 2,
    color: pink["500"]
  },
  csvicon: {
    m: 2,
    color: purple["500"]
  },
  jsonicon: {
    m: 2,
    color: green["800"]
  },
  zipicon: {
    m: 2,
    color: grey["500"]
  },
  customicon: {
    m: 2,
    color: pink["500"]
  },
  iconHover: {
    m: 2,
    '&:hover': {
      color: green[200],
    },
  },
};

class FlowForm extends Component<any,any> {
  form = createRef();
  constructor(props:any) {
    super(props);
    this.state = {
      conf: {},
      views:[],
      count:0,
      open: true,
      valid: false,
      loading: false,
      loadcolor: 'inherit',
      params:{s:props.service,a:'upload'},
      data: {},
      datasets: null,
      dataset: null
    };
  }

  formconfig = () => {
    const cbip = {InputLabelProps:{ shrink:true,}};
    const config = {
      service: {
        name: 'flowform',
        title: 'Generate Flow',
        eform: [
          { id:'rpt',label:'Upload Type',type:'fa',req:1,ops:{placeholder:'Select Type',strval:true,...cbip},cp:{t:'lcs',s:'uploadtype'}},
          { id:'fmt',label:'Upload Format',type:'fa',req:1,ops:{placeholder:'Select Format',strval:true,...cbip},cp:{t:'lcs',s:'format'}},
          { id:'sdt',label:'Start Date',type:'df',req:1,ops:{ placeholder:'Select Start Date'} },
          { id:'edt',label:'Stop Date',type:'df',req:1,ops:{ placeholder:'Select Stop Date'} }
        ],
      },
      create: true,
      actions: { add: 'Print' },
      panels: { add: 'simple' },
    };
    return config;
  }

  setValid = (data:any) => {
    const {config:conf} = this.props;
    const config = conf||this.formconfig();
    const valid = isValid(config,data);
    this.setState({valid});
  }

  onChange = (name:any) => (value:any) => {
    const {data} = this.state;
    const newdata = {...data,[name]:value};
    this.setValid(newdata);
    this.setState({data:newdata});
  }

  makeform = (conf:any) => {
    const config = conf||this.formconfig();
  
    const { record, classes, extras } = this.props;
    const sconfig = clone(config);
    const {service:sdata,type} = sconfig;
    const mode = 'add';
    const formatters = { dob: formatDate };
    const onChange = this.onChange.bind(this);
    const form = create(mode,sdata,record,formatters,onChange,classes,{...(extras||{}),ref:this.form});
    const title = sdata.title;
    return {title,form,type};
  }

  startLoading = () => {
    this.setState({loading:true});
  }

  stopLoading = () => {
    this.setState({loading:false});
  }

  handleClick = (name:any) => () => {
    var {data,record} = this.props;
    var d = new Download();
    d.downloadFile(name,data,record);
  } 

  onClick = (type:any) => async(event:any) => {
    try{
      const {config,service:name,action,record} = this.props;
      const {service:svc} = config||{};
      const {name:sname} = svc||{};
      const {params:sparams,data: extra} = this.state;
      const params = {...sparams,...extra,s:sname,a:'upload'};
      this.startLoading();
      await bizupload(type,params,name,extra,record);
    }
    catch(err){
      console.log('upload.handle.failed',err);
      const errormessage = errorMessage(err);
      this.props.showNotification(errormessage);
    }
    finally{
      console.log('leaving');
      this.stopLoading();
    }
  } 

  onExpChange = (event:any,expanded:boolean) => {
    if (!expanded) this.setState({open:false})
  }

  onClose = (event:any) => {
    const {setHome} = this.props;
    this.setState({open:false})
    if(typeof setHome === 'function'){
      setHome();
    }
  }

  render() {
    const {config,classes } = this.props;
    const {title,form,type} = this.makeform(config);
    const {open,valid,loading,loadcolor} = this.state;
    const offmode = !valid||loading;
    return (
      <Dialog open={open}>
        <DialogTitle id="window-dialog-title" sx={{...s.titlebar}} >
          <ClosableBar onClose={this.onClose}>{title}</ClosableBar>
        </DialogTitle>
        <DialogContent sx={{...s.dialogcontent}}>
        <Box sx={{...s.root}}>
          
          <Accordion defaultExpanded onChange={this.onExpChange}>
            <AccordionDetails sx={{...s.details}}>
              <Box sx={{...s.root}}>
              <LoadDialog open={loading} onClick={this.onClose} value={"wait!"} color={loadcolor} />
                {form}                
              </Box>
            </AccordionDetails>
            <Divider />
          <AccordionActions>
            <Button variant="contained" color="secondary" startIcon={<CSVIcon titleAccess="Cancel Upload"/>} sx={{...s.csvicon}} disabled={!loading} onClick={this.stopLoading}>
              Cancel
            </Button>
            <Button variant="contained" color="primary" startIcon={<JSONIcon titleAccess="API Testing"/>} sx={{...s.jsonicon}} disabled={offmode} onClick={this.onClick(type)}>
              Submit
            </Button>
          </AccordionActions>
        </Accordion>
      </Box>
      </DialogContent>
      </Dialog>
    );
  }
}

export default FlowForm;
